import { Asterisk } from "lucide-react";

const ITEMS = [
    "QUEER STORIES",
    "BOMBAY",
    "INTIMACY",
    "POLITICS",
    "BELONGING",
    "SOUTH ASIA",
    "DESIRE",
    "MEMORY",
    "CULTURE",
    "COMMUNITY",
];

export default function Marquee({ dark = false }) {
    const row = (key) => (
        <div key={key} className="flex items-center shrink-0">
            {ITEMS.map((item, i) => (
                <span key={`${key}-${i}`} className="flex items-center">
                    <span
                        className={`font-sub font-black text-2xl sm:text-4xl tracking-tight px-6 ${
                            i % 2 ? "text-pink" : dark ? "text-paper" : "text-ink"
                        }`}
                    >
                        {item}
                    </span>
                    <Asterisk className="w-6 h-6 text-mustard shrink-0" />
                </span>
            ))}
        </div>
    );

    return (
        <div
            data-testid="editorial-marquee"
            className={`overflow-hidden border-y-2 border-ink py-5 select-none ${
                dark ? "bg-ink" : "bg-mustard/25"
            }`}
            aria-hidden="true"
        >
            <div className="flex w-max animate-marquee">
                {row("a")}
                {row("b")}
            </div>
        </div>
    );
}
